export var ChatType;
(function (ChatType) {
    ChatType[ChatType["ControllerChat"] = 0] = "ControllerChat";
    ChatType[ChatType["FamilyChat"] = 1] = "FamilyChat";
    ChatType[ChatType["GptChat"] = 2] = "GptChat";
})(ChatType || (ChatType = {}));
//# sourceMappingURL=IChatService.js.map